import { useTheme as OriginalUseTheme } from '@emotion/react';

export default function useTheme() {
  return OriginalUseTheme();
}
